import { render, staticRenderFns } from "./EtapaAnexos.vue?vue&type=template&id=32368112"
import script from "./EtapaAnexos.vue?vue&type=script&lang=js"
export * from "./EtapaAnexos.vue?vue&type=script&lang=js"
import style0 from "./EtapaAnexos.vue?vue&type=style&index=0&id=32368112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports